import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import GoogleAnalytics from "./components/analytics/GoogleAnalytics";
import CookieConsent from "./components/privacy/CookieConsent";
import HashNavigation from './components/HashNavigation';
import ConversionEvents from './components/analytics/ConversionEvents';


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <GoogleAnalytics />
        <AppRoutes />
        <HashNavigation />
        <ConversionEvents />
        <CookieConsent />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
